export default [
  {
    path: 'monitor',
    name: 'firefightingMonitor',
    component: () => import('@/views/firefighting/monitor/index.vue'),
    redirect: { name: 'firefightingMonitorBMap' },
    meta: {
      activeMenu: '/firefighting',
      hidden: true,
      noPadding: true
    },
    children: [
      {
        path: 'map',
        name: 'firefightingMonitorBMap',
        component: () => import('@/views/firefighting/monitor/BMapGL/index.vue'),
        meta: {
          activeMenu: '/firefighting',
          hidden: true,
          noPadding: true
        }
      },
      {
        path: 'list',
        name: 'firefightingMonitorList',
        component: () => import('@/views/firefighting/monitor/List/index.vue'),
        meta: {
          activeMenu: '/firefighting',
          hidden: true,
          noPadding: true
        }
      }
    ]
  }
];
